import { ComponentProps } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FallbackRender } from '@sentry/react';
import { isAxiosError } from 'axios';
import { ErrorCodes } from 'constants/error-codes';
import { CONTACT_US_LINK } from 'constants/links';

const ErrorSplash = (props: FallbackProps | ComponentProps<FallbackRender>) => {
    const { error } = props;
    const code = isAxiosError(error) ? (error.response?.status ?? 0) : 0;

    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-10">
            <img alt="Givebutter Logo" src={`/images/logo.svg`} className="w-28" />
            <div className="flex max-w-sm flex-col gap-4 text-center">
                <ErrorContentByStatusCode code={code} />
            </div>
        </div>
    );
};

interface ErrorContentByStatusCodeProps {
    code: ErrorCodes;
}

const ErrorContentByStatusCode = (props: ErrorContentByStatusCodeProps) => {
    const { code } = props;
    switch (code) {
        case ErrorCodes.UNAUTHORIZED:
            return <p className="font-medium">Logging you out...</p>;
        case ErrorCodes.FORBIDDEN:
            return <p className="font-medium">You don't have permission to view this page.</p>;
        case ErrorCodes.RATE_LIMIT:
        default:
            return (
                <>
                    <p className="font-medium">
                        <FontAwesomeIcon icon={faExclamationCircle} className="text-orange-500" />{' '}
                        Uh-oh!
                    </p>
                    <p className={'text-sm text-gray-600'}>
                        An unexpected error occurred. Please refresh the page and try again. If this
                        issue persists,{' '}
                        <a
                            target="_blank"
                            className="text-blue-500"
                            rel="noreferrer noopener"
                            href={CONTACT_US_LINK}
                        >
                            contact us.
                        </a>
                    </p>
                </>
            );
    }
};

export { ErrorSplash };
